// 获取树的详情
// export const getTreeDetail = (data,apiInstance) => {
//   return apiInstance.post('api/utree/node/list/by-pnode-id', data);
// };
// 管理端查询父分类下的子分类数据---数组
export const getManageCategoryData = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/list/by-pnode-id', data);
};
// 学员端-根据关键字搜索分类数据-树结构
export const searchMgrCategoryByName = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/tree', data);
};

// 学员端-查询父分类下的子分类列表-数组
export const getStuCategoryData = (data, apiInstance) => {
  return apiInstance.post('api/utree/node/list/by-pnode-id', data);
};

// 学员端-根据关键字搜索分类数据-树结构
export const searchCategoryByName = (data, apiInstance) => {
  return apiInstance.post('api/utree/node/tree', data);
};

// 编辑分类
export const updateCate = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/update', data);
};

// 新建分类
export const insertCate = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/create', data);
};

// 删除分类
export const deleteCate = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/delete', data);
};

// 分类详情
export const getNodeDeatil = (data, apiInstance) => {
  return apiInstance.get('api/mgr/utree/node/detail/by-node-id', data);
};

// 树节点排序
export const sortNode = (data, apiInstance) => {
  return apiInstance.post('api/mgr/utree/node/sort', data);
};
